import styles from "./styles.module.css";

const CookiePolicy = () => (
  <div className={styles.content}>
    <h2>ÇEREZ (COOKIE) KULLANIMI</h2>
    <a href="#"></a>
    <p>
      Emlakjet.com olarak, ziyaretçilerimizin web sitemizde yaşadığı deneyimi iyileştirmek ve onlara daha iyi hizmet
      verebilmek için Çerez (Cookie) kullanıyoruz. Ziyaretçilerimiz, Çerez (Cookie) kullanımını tarayıcı ayarları
      üzerinden kontrol ederek engelleyebilir, önceki kullanımlara dair verileri silebilirler. Çerez (Cookie) kullanımın
      engellenmesi, ziyaretçilerimizin web sitemizde yaşadığı deneyimi etkileyebilir.
    </p>
    <p>
      Çerez (Cookie) kullanımını engellemeden Emlakjet.com’u kullanan ziyaretçilerimiz Çerez (Cookie) kullanımını kabul
      etmiş sayılır.
    </p>
    <strong>
      <br />
      Çerez (Cookie) Nedir?
      <br />
    </strong>
    <p>
      Çerez (Cookie), bir web sitesini /mobil siteyi ziyaret ettiğinizde veya bir mobil uygulamayı cihazınıza
      yüklediğinizde, ilgili site veya uygulama tarafından, tarayıcınız veya uygulama üzerinden cihazınıza (veya ağ
      sunucunuza) yüklenen ve saklanan küçük bilgi parçacıkları içeren metin dosyalarıdır.
    </p>
    <strong>
      <br />
      Çerez (Cookie) Türleri Nelerdir?
      <br />
    </strong>
    <strong className="memberContract">
      <br />
      Oturum Çerezleri (Session Cookies)
      <br />
    </strong>
    <p>
      Oturum Çerezleri, ziyaretçilerimizin mobil/web sitemizi ziyareti veya mobil uygulamalarımızı kullanımı esnasında
      etkin olan, tarayıcı veya mobil uygulama kapatıldığında silinen geçici çerezlerdir.
    </p>
    <p>
      Oturum Çerezlerinin ana kullanım amacı, ziyaret süresinde web/mobil sitenin veya mobil uygulamanın ziyaretçi
      tercihlerini hatırlayarak ilgili fonksiyonların düzgün çalışmasını sağlamaktır.
    </p>
    <p>
      Örneğin; Emlakjet.com’da emlak arayan bir ziyaretçimizin, ilan karşılaştırma özelliği ile karşılaştırmak üzere
      seçtiği ilanlar Oturum Çerezleri ile kaydedilir. Böylece, ziyaretçimiz farklı sayfalarda gezindiğinde
      kaybedilmemiş olur.
    </p>
    <strong>
      <br />
      Kalıcı Çerezler (Persistent Cookies)
      <br />
    </strong>
    <p>
      Kalıcı Çerezler, kullanıcı tercihlerini hatırlamaya yarayan ve kullanıcı tarafından silinene dek saklanan
      çerezlerdir. Kullanıcının web/mobil site veya uygulama üzerinde yaptığı hareketleri hatırlayarak sonraki kullanım
      deneyimlerinin özelleştirilmesine imkan verir.
    </p>
    <p>
      Örneğin; Emlakjet.com’a üye girişi yapan bir ziyaretçimiz, oturum açma işlemi esnasında “Beni Hatırla” seçeneğini
      aktif ettiğinde bir sonraki ziyareti için tekrar kullanıcı adı ve şifre bilgisi girişine gerek kalmadan oturumu
      açılacaktır. Bu işlevi yerine getirerek kullanım kolaylığı sağlayan veriler Kalıcı Çerezler sayesinde elde edilir.
    </p>
    <strong>
      <br />
      Performans Çerezleri (Perfomance Cookies)
      <br />
    </strong>
    <p>
      Performans Çerezleri, kullanıcıya özel bir bilgi ile ilişkilendirilmeden, ziyaret edilen web/mobil site ve
      uygulamaların performansını izleyen çerezlerdir. Hata mesajları gibi bilgileri toplar. Bu veriler ilgili web/mobil
      sitenin veya uygulamanın iyileştirilmesi amacıyla kullanılır.
    </p>
    <strong>
      <br />
      Fonksiyonel Çerezler (Functionality Cookies)
      <br />
    </strong>
    <p>
      Fonksiyonel Çerezler, kullanıcının web/mobil site veya uygulamada yaptığı kullanım tercihlerinin hatırlanmasını
      sağlar. Web /mobil sitenin veya uygulamanın kullanım dili gibi tercihler Fonksiyonel Çerezler sayesinde
      hatırlanır, kullanıcının sonraki ziyaretlerinde tekrar seçilmesine gerek duymadan uygulanır.
    </p>
    <strong>
      <br />
      Neden Çerez (Cookie) Kullanıyoruz?
      <br />
    </strong>
    <p>
      Emlakjet.com olarak, Çerez (Cookie) kullanımımızın amacı, ziyaretçilerimizin web/mobil sitemizde ve mobil
      uygulamalarımızda yaşadıkları deneyimi onlara özel hale getirerek iyileştirmektir. Çerez (Cookie) kullanımı,
      ziyaretçilerimizin tercihlerini hatırlayarak bize veri sağlar. Emlakjet.com’da görüntülenen sayfalar, kullanıcı
      adı ve parola bilgileri, ziyaret süreleri gibi veriler de bu kapsamdadır. Bu veriler, web/mobil sitemizin ve mobil
      uygulamamızın ziyaretçilerimiz için işlevselliğini artırmamıza, kişiye özel kampanya ve içerikler sunmamıza, web
      sitemizin kullanım kolaylığını ve uygunluğunu ölçerek geliştirmemize ve daha iyi hizmet vermemize olanak sağlar.
      Ek olarak, çerezler, belirlenen kullanıcı tercihlerine uygun reklam ve kampanyaların gösteriminde kullanılır.
      Böylece, Emlakjet.com’un reklam verdiği diğer internet sitelerini ziyaret ettiğiniz takdirde, size özel içerik ve
      kampanyalarımızı reklam alanlarında görebilirsiniz.
    </p>
    <strong>
      <br />
      Ziyaretçilerimizin Bilgilerinin Güvenliği
      <br />
    </strong>
    <p>
      Emlakjet.com olarak, ziyaretçilerimizin izin verdiği ölçüde ve yasal düzenlemeler çerçevesinde, edindiğimiz
      kullanıcı bilgilerini kaydediyor ve saklıyoruz. Ziyaretçilerimizle iletişime geçerek faydalı içerik, ürün ve
      kampanyalarımızın iletişimini yapıyoruz. Ziyaretçilerimizin iletişim bilgileri, kendilerine fayda sağlayabilecek
      üçüncü parti firmalar ile ürün ve kampanyalarının tanıtımı için paylaşılabilmektedir. Ek olarak, edinilen
      bilgiler, Emlakjet.com’u bünyesinde barındıran iLab Ventures ile paylaşılmakta, iLab Ventures ve iştiraki olan
      diğer firmalar tarafından kullanılabilmektedir.
    </p>
    <strong>
      <br />
      Çerez (Cookie) Kullanımının Yönetimi
      <br />
    </strong>
    <p>
      Ziyaretçilerimiz tarayıcı ayarları üzerinden çerezlere ilişkin tercihlerini yöneterek bilgi paylaşımını
      kısıtlayabilirler. Bu durumda web/mobil site veya mobil uygulama bazı işlevlerini yerine getiremeyebilir. Çerez
      kullanımını engelleyen ziyaretçilerimiz, buna bağlı olarak gelişebilecek performans sorunlarını kabul etmiş
      sayılırlar.
    </p>
    <br />
    <table>
      <tbody>
        <tr>
          <td>Adobe Analytics</td>
          <td>
            <a href="http://www.adobe.com/uk/privacy/opt-out.html" style={{ outline: "none" }}>
              http://www.adobe.com/uk/privacy/opt-out.html
            </a>
          </td>
        </tr>
        <tr>
          <td>AOL</td>
          <td>
            <a href="https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser">
              https://help.aol.com/articles/restore-security-settings-and-enable-cookie-settings-on-browser
            </a>
          </td>
        </tr>
        <tr>
          <td>Google Adwords</td>
          <td>
            <a href="https://support.google.com/ads/answer/2662922?hl=en">
              https://support.google.com/ads/answer/2662922?hl=en
            </a>
          </td>
        </tr>
        <tr>
          <td>Google Analytics</td>
          <td>
            <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a>
          </td>
        </tr>
        <tr>
          <td>Google Chrome</td>
          <td>
            <a href="http://www.google.com/support/chrome/bin/answer.py?hl=en&answer=95647">
              http://www.google.com/support/chrome/bin/answer.py?hl=en&amp;answer=95647
            </a>
          </td>
        </tr>
        <tr>
          <td>Internet Explorer</td>
          <td>
            <a href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies">
              https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies
            </a>
          </td>
        </tr>
        <tr>
          <td>MozillaFirefox</td>
          <td>
            <a href="http://support.mozilla.com/en-US/kb/Cookies">http://support.mozilla.com/en-US/kb/Cookies</a>
          </td>
        </tr>
        <tr>
          <td>Opera</td>
          <td>
            <a href="http://www.opera.com/browser/tutorials/security/privacy/">
              http://www.opera.com/browser/tutorials/security/privacy/
            </a>
          </td>
        </tr>
        <tr>
          <td>Safari</td>
          <td>
            <a href="https://support.apple.com/kb/ph19214?locale=tr_TR">
              https://support.apple.com/kb/ph19214?locale=tr_TR
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default CookiePolicy;
